import React from 'react';
import { createComponent } from '@lit/react';
import { IxGridNavigation } from './components/IxGridNav.js';

export const IxGridNav = createComponent({
  tagName: 'ix-grid-nav-react',
  elementClass: IxGridNavigation,
  react: React,
});
